// @actions
const brokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const { BROKER_MIFID_REJECT_ACTION } = require('constants/index');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_GO_TO_MAKE_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS
} = require('constants/actionTypes.js');

const goToMakeTest = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_GO_TO_MAKE_TEST,
        payload: {}
    });
};

const changeTranscription = (transcription) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION,
        payload: {
            transcription
        }
    });
};

const cancel = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL,
        payload: {}
    });
};

const confirm = (clientEmail, history) => (dispatch) => {
    dispatch(brokerConvenienceMiFIDTestActions.finish(clientEmail, BROKER_MIFID_REJECT_ACTION, history));
};

const validateTranscriptionCC = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS,
        payload: {}
    });
}

const validateTranscription = () => (dispatch, getState) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE,
        payload: {
            requiredText: getState().brokerConvenienceMiFIDTest.get('repeatSentenceClean')
        }
    });

    const immBrokerConvenienceMifidTest = getState().brokerConvenienceMiFIDTest;

    if (!immBrokerConvenienceMifidTest.get('omitTestInvalidText')) {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS,
            payload: {}
        });
    }
};

module.exports = {
    goToMakeTest,
    changeTranscription,
    cancel,
    confirm,
    validateTranscription: __CONTACT_CENTER__ ? validateTranscriptionCC : validateTranscription
};
